(function (module) {
    "use strict";

    module.component('forecastSaveAsNew', {
        template: require('./forecastSaveAsNewComponent.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: ['$scope', function(this: $TSFixMe, $scope: $TSFixMe) {
            var $ctrl = this;

            $ctrl.$onInit = function () {
                $ctrl.forecastId = $ctrl.resolve.forecastId;
                $ctrl.forecastName = $ctrl.resolve.name;
            };
            $ctrl.ok = function () {
                $ctrl.close({ $value: $ctrl.forecastName });
            };

            $ctrl.cancel = function () {
                $ctrl.dismiss({ $value: 'cancel' });
            };
        }]
    })

})(angular.module('topline.modules'));